import EventSection from "./components/EventSection.svelte"
import SpecialEvents from "./components/SpecialEvents.svelte"

new EventSection({ target: document.getElementById("events") })
new SpecialEvents({ target: document.getElementById("special-events") })
